import { __experimentalUnitControl as UnitControl } from '@wordpress/components';
import { useState } from '@wordpress/element';
import { SVG, Path } from '@wordpress/primitives';
import { __ } from '@wordpress/i18n';


export function VayuBlocksUnitControl({
    max=200,
    min=0,
    label="unit",
    initialPosition=0,
    help="",
    labelPosition="side",
    attribute={key: "value", value: 0},
    onChange
}){

    return(<UnitControl
        label={label}
         labelPosition={labelPosition}
         min={min}
         max={max}
        onChange={(value) =>onChange(value)}
        value={attribute.value}
      />)
}